// Tracks whether this browser has completed the scripted onboarding demo. No account
// system is live yet, so "has this player seen it" can only mean "has this browser seen
// it" — same constraint and try/catch pattern as LanguageContext's `lang` persistence.
//
// Bump TUTORIAL_VERSION when the demo's content changes significantly — that naturally
// shows it once more to everyone (a fresh version string no longer matches what's stored),
// with no migration needed.
const TUTORIAL_VERSION = "v1"
const STORAGE_KEY = "godfathers-table:onboardingSeen"

export function hasSeenOnboarding(): boolean {
  try { return localStorage.getItem(STORAGE_KEY) === TUTORIAL_VERSION } catch { return false }
}

export function markOnboardingSeen(): void {
  try { localStorage.setItem(STORAGE_KEY, TUTORIAL_VERSION) } catch { /* ignore */ }
}
